<template>
    <div>
        <div class="page-title">
            <h4 v-if='this.vtp'> {{$t('txt.vtp')}}</h4>
        </div>
        <form class="add-user-form">
            <div class="row">
                <div class="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div class="account-detail-box">
                        <ul class="account-detail-list">
                            <sequential-entrance fromTop delay="70">
                                <li v-for="input_field in vtp_fields.column_1" :key="input_field.id">
                                  <div class="view-info-wrapper">
                                    <div class="contact-design">
                                      <i :class="input_field.icon"></i>
                                      <span> {{input_field.labelName}} </span>
                                    </div>
                                    <p> {{input_field.inputValue}} </p>
                                  </div>
                                </li>
                            </sequential-entrance>
                        </ul>
                    </div>
                </div>
                <div class="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div class="account-detail-box">
                        <ul class="account-detail-list">
                            <sequential-entrance fromTop delay="70">
                                <li v-for="input_field in vtp_fields.column_2" :key="input_field.id">
                                  <div class="view-info-wrapper">
                                    <div class="contact-design">
                                      <i :class="input_field.icon"></i>
                                      <span> {{input_field.labelName}} </span>
                                    </div>
                                    <p> {{input_field.inputValue}} </p>
                                  </div>
                                </li>
                            </sequential-entrance>
                        </ul>
                    </div>
                </div>
            </div>
        </form>
        <div class="offer-footer" v-if="vtp.done_date == null">
            <div class="offer-footer-buttons">
                <div class="offer-button-preview">
                    <button type="button" class="template-button"  @click="$bvModal.show('modal-scoped')">
                        <i class="fas fa-hammer"></i>
                        {{$t('txt.efectueazaLucrare')}}
                    </button>
                </div>
            </div>
        </div>
        <b-modal class="vtp-modal" id="modal-scoped" v-b-modal.modal-scrollable v-if="vtp.done_date == null">
            <template slot="default">
              <form class="add-user-form" id="execute-vtp">
                <input type="hidden" name="_method" value="put" />
                  <div class="vtp-modal-wrapper">
                    <h4> {{$t('placeholder.dataRealizata')}}: </h4>
                    <div class="vtp-work-schedule">
                        <div class="form-group">
                            <date-picker v-validate="'required'" name="date" v-model="date" type="datetime" lang="en" format="YYYY-MM-DD HH:mm:ss"></date-picker>
                            <p class="custom-error-info"> {{errors.first('date')}} </p>
                        </div>
                    </div>
                  </div>
              </form>
            </template>
            <template slot="modal-footer" slot-scope="{ ok }">
              <button type="button" class="template-button" @click="vtpExecute()" >
                {{$t('txt.efectueazaLucrare')}}
              </button>
              <button type="button" class="template-button" @click="ok()">
                  <i class="far fa-times-circle"></i>
              </button>
            </template>
        </b-modal>
    </div>
</template>

<script>
import DatePicker from 'vue2-datepicker'
import ServiceServices from '../../api-services/service.service.js'
export default {
  name: 'viewvtp',
  data () {
    return {
      vtp: [],
      date: null
    }
  },
  components: {
    DatePicker
  },
  computed: {
    vtp_fields () {
      return {
        column_1: [
          {
            inputName: 'client_id',
            labelName: this.$t('placeholder.numeClient'),
            inputValue: (this.vtp) ? ((this.vtp.client) ? this.vtp.client.last_name : null) : null,
            icon: 'fas fa-signature',
            validationRules: ''
          },
          {
            inputName: 'product_id',
            labelName: this.$t('placeholder.numeProdus'),
            inputValue: (this.vtp) ? ((this.vtp.product) ? this.vtp.product.name : null) : null,
            icon: 'fas fa-signature',
            validationRules: ''
          },
          {
            inputName: 'start_date',
            labelName: this.$t('placeholder.dataRealizare'),
            inputValue: (this.vtp) ? this.vtp.start_date : null,
            icon: 'fas fa-signature',
            validationRules: ''
          },
          {
            inputName: 'done_date',
            labelName: this.$t('placeholder.dataRealizata'),
            inputValue: (this.vtp) ? this.vtp.done_date : null,
            icon: 'fas fa-signature',
            validationRules: ''
          },
          {
            inputName: 'billing_number',
            labelName: this.$t('placeholder.numarFactura'),
            inputValue: (this.vtp) ? this.vtp.billing_number : null,
            icon: 'fas fa-signature',
            validationRules: ''
          }
        ]
      }
    }
  },
  methods: {
    getVtp () {
      ServiceServices.get(this.$route.params.id)
        .then((response) => {
          this.vtp = response.data.data
          this.date = this.vtp.start_date
        })
        .catch((error) => {
          console.log(error)
        })
    },
    vtpExecute () {
      let formData = new FormData(document.getElementById("execute-vtp"))
      formData.append('execute_vtp', 1)
      ServiceServices.update(this.$route.params.id, formData)
        .then((response) => {
          this.vtp = response.data.data
        })
        .catch((error) => {
          console.log(error)
        })
    }
  },
  mounted () {
    this.$store.dispatch('hideLoading')
    this.getVtp()
  }
}
</script>
